import React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./features/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Capacitor } from "@capacitor/core";

export let persistor = persistStore(store);

// Add platform-specific font sizing for Android - directly set on html element
const platform = Capacitor.getPlatform();
console.log('Capacitor Platform:', platform);

if (platform === 'android') {
  // Set font-size directly on html element
  document.documentElement.style.fontSize = '85%';
  document.documentElement.classList.add('capacitor-android');
  document.body.classList.add('capacitor-android');
  console.log('Applied 85% font-size to html element for Android');
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
